import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MandantLogoComponent } from './mandant-logo.component';



@NgModule({
  declarations: [
    MandantLogoComponent
  ],
  imports: [
    CommonModule
  ],
  exports: [
    MandantLogoComponent
  ]
})
export class MandantLogoModule { }
